import { Component, NgZone, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { ProcessService } from 'src/app/_provider/processes/processes.service';
import { ProcessBase, ProcessPosition } from 'src/app/_provider/processes/processes.types';
import { WawiConnectorService } from 'src/app/_provider/wawi-connector/wawi-connector.service';

@Component({
    selector: 'app-process-detail',
    templateUrl: './process-detail.page.html',
    styleUrls: ['./process-detail.page.scss'],
    standalone: false
})
export class ProcessDetailPage implements OnInit {

  public isLoading: boolean = true;

  public process: ProcessBase
  public positions: ProcessPosition[] = [];

  constructor(
    private modalCtrl: ModalController,
    private processService: ProcessService,
    private feedback: FeedbackService,
    private ngZone: NgZone,
    public wawiConnectorSrv: WawiConnectorService
  ) { }

  async ngOnInit() {

    await Promise.all([
      this.loadPositions(),
      this.wawiConnectorSrv.initConnector()
    ])
  }

  private async loadPositions(){
    const result: HttpFunctionResult<ProcessPosition[]> = await this.processService.getPositions(this.process.id);
    this.ngZone.run(() => this.isLoading = false)
    if(result.success) this.positions = result.data;
  }

  public async close(){
    await this.modalCtrl.dismiss();
  }

  public async openProcess(){
    if(this.wawiConnectorSrv.connector.executable){
      const openResult: HttpFunctionResult = await this.wawiConnectorSrv.connector.openProcess(this.process.id);
      if(openResult.success) this.feedback.showInformationToast(`Vorgang wurde in ${this.wawiConnectorSrv.appName} geöffnet.`, "Information", 2000);
      else this.feedback.showError(openResult.message)
    }
  }

}
